export const ShoppingProductGroupCode = {
    Fee: "FEE",
    Surcharge: "SURCHARGE",
    Markup: "MARKUP",
    Discount: "DISCOUNT",
    SSR: "SSR",
    SEAT: "SEAT"
}